import { EventsList } from '../components/EventsList';

export const EventsPage: React.FC = () => (
  <section id="events" className="page-section">
    <div className="page-header">
      <div>
        <p className="page-eyebrow">Calendar</p>
        <h2 className="page-title">Events</h2>
        <p className="page-copy">Scheduled club events and activity planning.</p>
      </div>
    </div>
    <EventsList />
  </section>
);
